(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_1e4b533"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.customElements || customElements.get('product-specs')) return;

    var STORE = 'psb-pincode';
    var UNIT = 'psb-unit';
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var NUM = '(\\d+)\\s+(\\d+)\\/(\\d+)|(\\d+(?:[.,]\\d+)?)';
    var TONES = ['var(--psb-accent)', 'color-mix(in srgb, var(--psb-accent) 55%, var(--psb-fg))', 'color-mix(in srgb, var(--psb-fg) 60%, transparent)', 'color-mix(in srgb, var(--psb-accent) 30%, transparent)', 'color-mix(in srgb, var(--psb-fg) 25%, transparent)'];

    var norm = function (s) { return String(s == null ? '' : s).trim().toLowerCase(); };
    var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
    var toNumber = function (a, b, c, d) { return d ? parseFloat(d.replace(',', '.')) : +a + b / c; };
    var trim = function (n, digits) { return String(+n.toFixed(digits)); };
    var still = function () { return reduce && reduce.matches; };

    function convert(v, to) {
      if (to === 'cm') { var cm = v * 2.54; return trim(cm, cm < 30 ? 1 : 0); }
      var inch = v / 2.54, step = inch < 20 ? 0.25 : 0.5;
      return trim(Math.round(inch / step) * step, 2);
    }
    function convertText(text, to) {
      return text.replace(new RegExp(NUM, 'g'), function (m, a, b, c, d) { return convert(toNumber(a, b, c, d), to); });
    }
    function addDays(start, count, skip) {
      var d = new Date(start), left = count;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (skip === 'sundays' && day === 0) continue;
        if (skip === 'weekends' && (day === 0 || day === 6)) continue;
        left--;
      }
      return d;
    }

    class ProductSpecs extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.classList.add('psb-js');
        if (!this._wired) {
          this._wired = true;
          this.addEventListener('click', function (e) { self.onClick(e); });
          this.addEventListener('input', function (e) {
            if (e.target.matches && e.target.matches('[data-psb-pin]')) {
              e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6);
              var err = self.querySelector('[data-psb-error]');
              if (err) err.hidden = true;
            }
          });
          this.addEventListener('keydown', function (e) { self.onKey(e); });
          this._select = function (e) { if (e.target && self.contains(e.target)) self.open(); };
          this._outside = function (e) { if (!self.contains(e.target)) self.syncSize(); };
        }
        document.addEventListener('shopify:block:select', this._select);
        document.addEventListener('change', this._outside);

        if (this._ready) return;
        var start = function () {
          if (self._ready) return;
          self._ready = true;
          var dialog = self.querySelector('dialog');
          if (dialog) dialog.addEventListener('cancel', function (e) { e.preventDefault(); self.close(); });
          self.initDebug();
          self.initComposition();
          self.initNav();
          self.initSizes();
          self.initFit();
          self.restore();
          self.reveal(true);
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
        else start();
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this._select);
        document.removeEventListener('change', this._outside);
        document.documentElement.classList.remove('psb-lock');
        if (this._spy) this._spy();
      }

      scope() { return this.closest('product-information') || this.closest('.shopify-section') || document; }

      /* ── open / close ── */
      isInline() { return !!this.querySelector('[data-psb-inline]'); }

      toggle() {
        var inline = this.querySelector('[data-psb-inline]');
        if (inline && !inline.hidden) this.close(); else this.open();
      }

      open() {
        var trigger = this.querySelector('[data-psb-open]');
        var dialog = this.querySelector('dialog');
        this.syncSize();
        if (!dialog) {
          var inline = this.querySelector('[data-psb-inline]');
          if (inline) {
            inline.hidden = false;
            void inline.offsetWidth;
            inline.classList.add('is-open');
          }
        } else if (!dialog.open) {
          dialog.removeAttribute('data-closing');
          if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
          document.documentElement.classList.add('psb-lock');
        }
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        this.reveal(false);
        this.watchScroll();
      }

      close() {
        var self = this;
        var trigger = this.querySelector('[data-psb-open]');
        var dialog = this.querySelector('dialog');
        if (!dialog) {
          var inline = this.querySelector('[data-psb-inline]');
          if (inline && !inline.hidden) {
            inline.classList.remove('is-open');
            var hide = function () { inline.hidden = true; };
            if (still()) hide(); else setTimeout(hide, 460);
          }
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          return;
        }
        if (!dialog.open || this._closing) return;
        this._closing = true;
        var finish = function () {
          if (!self._closing) return;
          self._closing = false;
          dialog.removeAttribute('data-closing');
          if (dialog.open) dialog.close();
          document.documentElement.classList.remove('psb-lock');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        };
        if (still()) return finish();
        dialog.setAttribute('data-closing', '');
        var sheet = dialog.querySelector('.psb__sheet');
        var timer = setTimeout(finish, 420);
        sheet.addEventListener('animationend', function done(ev) {
          if (ev.target !== sheet) return;
          sheet.removeEventListener('animationend', done);
          clearTimeout(timer);
          finish();
        });
      }

      /* ── staged reveal: cards, count-up, gauge, bars ── */
      reveal(initial) {
        var self = this, cards = this.querySelectorAll('[data-psb-card]');
        var motion = this.getAttribute('data-motion') !== '0' && !still();
        if (!motion) { each(cards, function (c) { c.classList.add('is-in'); }); this.countUp(false); return; }
        if (initial && this.querySelector('dialog')) return; /* dialog content waits for open() */
        each(cards, function (c) { c.classList.remove('is-in'); });
        void this.offsetWidth;
        each(cards, function (c, i) { setTimeout(function () { c.classList.add('is-in'); }, 160 + i * 90); });
        this.countUp(true);
      }

      countUp(animate) {
        each(this.querySelectorAll('.psb__count'), function (el) {
          var to = parseFloat(el.getAttribute('data-to'));
          if (isNaN(to)) return;
          if (!animate) { el.textContent = to; return; }
          var t0 = null, dur = 1100;
          el.textContent = '0';
          var step = function (t) {
            if (t0 === null) t0 = t;
            var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 4);
            el.textContent = Math.round(to * e);
            if (p < 1) requestAnimationFrame(step); else el.textContent = to;
          };
          setTimeout(function () { requestAnimationFrame(step); }, 300);
        });
      }

      initDebug() {
        var box = this.querySelector('[data-psb-debug]');
        if (!box) return;
        box.hidden = !((window.Shopify && window.Shopify.designMode) || /[?&]specs-debug/.test(location.search));
      }

      /* ── section shortcuts + scroll spy ── */
      initNav() {
        var nav = this.querySelector('[data-psb-nav]');
        if (!nav) return;
        var cards = this.querySelectorAll('[data-psb-card]');
        if (cards.length < 3) { nav.hidden = true; return; }
        nav.textContent = '';
        each(cards, function (c, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.setAttribute('data-psb-goto', String(i));
          b.textContent = c.getAttribute('data-title') || ('Section ' + (i + 1));
          nav.appendChild(b);
        });
        nav.hidden = false;
        nav.firstChild.classList.add('is-active');
      }

      watchScroll() {
        var scroller = this.querySelector('[data-psb-scroller]'), nav = this.querySelector('[data-psb-nav]');
        if (!scroller || !nav || nav.hidden || this._spy) return;
        var self = this, ticking = false;
        var update = function () {
          ticking = false;
          var cards = self.querySelectorAll('[data-psb-card]'), top = scroller.getBoundingClientRect().top + 90, active = 0;
          each(cards, function (c, i) { if (c.getBoundingClientRect().top <= top) active = i; });
          each(nav.children, function (b, i) { b.classList.toggle('is-active', i === active); });
        };
        var on = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
        scroller.addEventListener('scroll', on, { passive: true });
        this._spy = function () { scroller.removeEventListener('scroll', on); self._spy = null; };
      }

      /* ── fabric composition: "80% Cotton, 20% Polyester" ── */
      initComposition() {
        var holder = this.querySelector('[data-psb-comp]');
        if (!holder) return;
        var raw = holder.getAttribute('data-raw') || '';
        var re = /(\d+(?:[.,]\d+)?)\s*%\s*([A-Za-z][A-Za-z\- ]*)/g, m, parts = [], total = 0;
        while ((m = re.exec(raw))) { var v = parseFloat(m[1].replace(',', '.')); parts.push({ v: v, n: m[2].trim() }); total += v; }
        if (parts.length < 2 || total <= 0) return;
        var bar = document.createElement('div'); bar.className = 'psb__comp-bar'; bar.setAttribute('role', 'img');
        var key = document.createElement('div'); key.className = 'psb__comp-key';
        var label = [];
        parts.forEach(function (p, i) {
          var tone = TONES[i % TONES.length];
          var seg = document.createElement('span'); seg.className = 'psb__comp-seg';
          seg.style.setProperty('--w', (p.v / total * 100) + '%'); seg.style.setProperty('--tone', tone);
          bar.appendChild(seg);
          var k = document.createElement('span'); k.style.setProperty('--tone', tone);
          var b = document.createElement('b'); b.textContent = p.v + '% ';
          k.appendChild(b); k.appendChild(document.createTextNode(p.n)); key.appendChild(k);
          label.push(p.v + '% ' + p.n);
        });
        bar.setAttribute('aria-label', label.join(', '));
        holder.appendChild(bar); holder.appendChild(key); holder.hidden = false;
      }

      /* ── fit tiles: tap to read what a fit means ── */
      initFit() {
        var note = this.querySelector('[data-psb-fitnote]');
        if (!note) return;
        this._fitDefault = note.innerHTML;
      }

      showFit(btn) {
        var note = this.querySelector('[data-psb-fitnote]');
        if (!note) return;
        var def = btn.getAttribute('data-def'), term = btn.getAttribute('data-term');
        var same = btn.classList.contains('is-shown');
        each(this.querySelectorAll('.psb__fit-item'), function (b) { b.classList.remove('is-shown'); });
        note.textContent = '';
        if (same) { note.innerHTML = this._fitDefault || ''; return; }
        btn.classList.add('is-shown');
        if (!def) return;
        var p = document.createElement('p'), s = document.createElement('strong');
        s.textContent = term + '. ';
        p.appendChild(s); p.appendChild(document.createTextNode(def));
        note.appendChild(p);
      }

      toggleInfo(btn) {
        var box = btn.closest('.psb__card').querySelector('.psb__infobox');
        if (!box) return;
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        box.classList.toggle('is-open', open);
        box.setAttribute('aria-hidden', open ? 'false' : 'true');
      }

      /* ── garment diagram + size picker ── */
      initSizes() {
        var card = this.querySelector('[data-psb-size]');
        if (!card) return;
        var host = card.querySelector('[data-psb-sizes]');
        this._rows = Array.prototype.slice.call(card.querySelectorAll('tbody tr[data-size]'));
        var stored = null; try { stored = localStorage.getItem(UNIT); } catch (err) {}
        if (!host) { this.applyUnit(stored && card.querySelector('[data-psb-unit]') ? stored : null, false); return; }
        host.textContent = '';
        this._rows.forEach(function (r) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'psb__size'; b.setAttribute('data-size', r.getAttribute('data-size'));
          b.setAttribute('aria-pressed', 'false'); b.textContent = r.getAttribute('data-size');
          if (r.hasAttribute('data-soldout')) { b.classList.add('is-out'); b.title = 'Sold out'; }
          host.appendChild(b);
        });
        this.applyUnit(stored && card.querySelector('[data-psb-unit]') ? stored : null, false);
        var first = this._rows.filter(function (r) { return !r.hasAttribute('data-soldout'); })[0] || this._rows[0];
        var mid = this._rows[Math.floor((this._rows.length - 1) / 2)];
        this.setSize(this.selectedOutside() || (mid && !mid.hasAttribute('data-soldout') ? mid.getAttribute('data-size') : first && first.getAttribute('data-size')));
        this.syncSize();
      }

      selectedOutside() {
        var self = this, found = null, rows = this._rows || [], vals = [];
        each(this.scope().querySelectorAll('input[type="radio"]:checked'), function (i) { if (!self.contains(i)) vals.push(norm(i.value)); });
        each(this.scope().querySelectorAll('select'), function (s) { if (!self.contains(s)) vals.push(norm(s.value)); });
        rows.forEach(function (r) { if (!found && vals.indexOf(norm(r.getAttribute('data-size'))) > -1) found = r.getAttribute('data-size'); });
        return found;
      }

      syncSize() {
        if (!this._rows || !this._rows.length) return;
        var sel = this.selectedOutside();
        each(this.querySelectorAll('.psb__size'), function (b) { b.classList.toggle('is-sel', !!sel && norm(b.getAttribute('data-size')) === norm(sel)); });
        if (sel && sel !== this._active && this.querySelector('[data-psb-sizes]')) this.setSize(sel);
      }

      cellText(row, role) {
        var cell = row.querySelector('td[data-role="' + role + '"]');
        return cell ? cell.textContent.trim() : '';
      }

      origText(row, role) {
        var cell = row.querySelector('td[data-role="' + role + '"]');
        if (!cell) return '';
        var o = cell.getAttribute('data-orig');
        return o !== null ? o : cell.textContent;
      }

      setSize(size) {
        var card = this.querySelector('[data-psb-size]');
        if (!card || !this._rows) return;
        var row = null;
        this._rows.forEach(function (r) { if (norm(r.getAttribute('data-size')) === norm(size)) row = r; });
        if (!row) return;
        this._active = row.getAttribute('data-size');
        var unit = this.current || card.getAttribute('data-unit') || 'in';

        this._rows.forEach(function (r) { r.classList.toggle('is-active', r === row); });
        each(card.querySelectorAll('.psb__size'), function (b) { b.setAttribute('aria-pressed', norm(b.getAttribute('data-size')) === norm(size) ? 'true' : 'false'); });

        var self = this;
        var scaleOf = function (role, current) {
          var vals = self._rows.map(function (r) { var n = parseFloat(self.origText(r, role)); return isNaN(n) ? null : n; }).filter(function (v) { return v !== null; });
          if (vals.length < 2 || current === null) return 1;
          var min = Math.min.apply(null, vals), max = Math.max.apply(null, vals);
          return max === min ? 1 : 0.9 + 0.2 * ((current - min) / (max - min));
        };
        var kind = card.getAttribute('data-kind');
        var wRole = kind === 'bottom' ? 'waist' : 'chest', hRole = kind === 'bottom' ? 'inseam' : 'length';
        var cw = parseFloat(this.origText(row, wRole)), ch = parseFloat(this.origText(row, hRole));
        var sx = scaleOf(wRole, isNaN(cw) ? null : cw), sy = scaleOf(hRole, isNaN(ch) ? null : ch);
        var garment = card.querySelector('.psb__garment');
        if (garment) { garment.style.setProperty('--sx', sx.toFixed(3)); garment.style.setProperty('--sy', sy.toFixed(3)); }

        var stage = card.querySelector('.psb__stage');
        var ox = stage ? +stage.getAttribute('data-ox') : 0, oy = stage ? +stage.getAttribute('data-oy') : 0;
        var W = stage ? +stage.getAttribute('data-w') : 1, H = stage ? +stage.getAttribute('data-h') : 1;
        var heads = {};
        each(card.querySelectorAll('thead th[data-role]'), function (th) { heads[th.getAttribute('data-role')] = th.childNodes[0] ? th.childNodes[0].textContent.trim() : ''; });
        var shown = {};
        each(card.querySelectorAll('.psb__dim'), function (dim) {
          var role = dim.getAttribute('data-role'), val = self.cellText(row, role);
          if (!val) { dim.hidden = true; return; }
          shown[role] = true;
          dim.hidden = false;
          dim.querySelector('i').textContent = heads[role] || role;
          dim.querySelector('b').textContent = val + ' ' + unit;
          var x = +dim.getAttribute('data-x'), y = +dim.getAttribute('data-y');
          dim.style.left = ((ox + (x - ox) * sx) / W * 100) + '%';
          dim.style.top = ((oy + (y - oy) * sy) / H * 100) + '%';
        });
        each(card.querySelectorAll('.psb__dl'), function (dl) { dl.classList.toggle('is-off', !shown[dl.getAttribute('data-role')]); });

        var pills = card.querySelector('[data-psb-pills]');
        if (pills) {
          pills.textContent = '';
          var ths = card.querySelectorAll('thead th');
          each(row.children, function (cell, i) {
            if (i === 0 || shown[cell.getAttribute('data-role')]) return;
            var li = document.createElement('li');
            var s = document.createElement('span'); s.textContent = ths[i] && ths[i].childNodes[0] ? ths[i].childNodes[0].textContent.trim() : '';
            var b = document.createElement('b'); b.textContent = cell.textContent.trim();
            li.appendChild(s); li.appendChild(b); pills.appendChild(li);
          });
        }

        var pick = card.querySelector('[data-psb-pick]');
        if (pick) {
          pick.hidden = row.hasAttribute('data-soldout');
          pick.setAttribute('data-size', this._active);
          pick.textContent = (pick.getAttribute('data-tpl') || '{size}').replace('{size}', this._active);
        }
      }

      applyUnit(unit, save) {
        var card = this.querySelector('[data-psb-size]');
        if (!card) return;
        var base = card.getAttribute('data-unit') || 'in';
        var next = unit === 'cm' || unit === 'in' ? unit : base;
        this.current = next;
        each(card.querySelectorAll('[data-conv]'), function (cell) {
          var o = cell.getAttribute('data-orig') || '';
          cell.textContent = next === base ? o : convertText(o, next);
        });
        each(card.querySelectorAll('[data-psb-ul]'), function (el) { el.textContent = '(' + next + ')'; });
        each(card.querySelectorAll('[data-psb-unit]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-psb-unit') === next ? 'true' : 'false'); });
        if (save) { try { localStorage.setItem(UNIT, next); } catch (err) {} }
        if (this._active) this.setSize(this._active);
      }

      pick(size) {
        var self = this, wanted = norm(size), hit = false, scope = this.scope();
        each(scope.querySelectorAll('input[type="radio"]'), function (i) {
          if (hit || i.disabled || self.contains(i) || norm(i.value) !== wanted) return;
          hit = true;
          if (!i.checked) i.click();
        });
        if (!hit) {
          each(scope.querySelectorAll('select'), function (s) {
            if (hit || self.contains(s)) return;
            each(s.options, function (o) {
              if (hit || o.disabled || norm(o.value) !== wanted) return;
              hit = true; s.value = o.value; s.dispatchEvent(new Event('change', { bubbles: true }));
            });
          });
        }
        if (hit) setTimeout(function () { self.close(); }, 250);
      }

      /* ── clicks + keys ── */
      onClick(e) {
        var t = e.target.closest ? e.target : null;
        if (!t) return;
        if (t.closest('[data-psb-open]')) { this.toggle(); return; }
        if (t.closest('[data-psb-close]')) { this.close(); return; }
        var info = t.closest('[data-psb-info]');
        if (info) { this.toggleInfo(info); return; }
        var fit = t.closest('[data-psb-fit]');
        if (fit) { this.showFit(fit); return; }
        var go = t.closest('[data-psb-goto]');
        if (go) {
          var card = this.querySelectorAll('[data-psb-card]')[+go.getAttribute('data-psb-goto')];
          var sc = this.querySelector('[data-psb-scroller]');
          if (card && sc) sc.scrollTo({ top: card.offsetTop - 56, behavior: still() ? 'auto' : 'smooth' });
          return;
        }
        var size = t.closest('.psb__size');
        if (size) { this.setSize(size.getAttribute('data-size')); return; }
        var unit = t.closest('[data-psb-unit]');
        if (unit) { this.applyUnit(unit.getAttribute('data-psb-unit'), true); return; }
        var pick = t.closest('[data-psb-pick]');
        if (pick) { this.pick(pick.getAttribute('data-size')); return; }
        if (t.closest('[data-psb-check]')) this.check(true);
      }

      onKey(e) {
        if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-psb-pin]')) { e.preventDefault(); this.check(true); return; }
        var inline = this.querySelector('[data-psb-inline]');
        if (e.key === 'Escape' && inline && !inline.hidden) {
          this.close();
          var trigger = this.querySelector('[data-psb-open]');
          if (trigger) trigger.focus();
        }
      }

      /* ── delivery timeline ── */
      restore() {
        var box = this.querySelector('[data-psb-delivery]');
        var input = this.querySelector('[data-psb-pin]');
        if (!box || !input || box.dataset.remember !== 'true') return;
        var saved = null; try { saved = localStorage.getItem(STORE); } catch (err) {}
        if (saved && /^\d{6}$/.test(saved)) { input.value = saved; this.check(false); }
      }

      estimate(box) {
        var min = parseInt(box.dataset.min, 10) || 5, max = parseInt(box.dataset.max, 10) || 7;
        var skip = box.dataset.skip || 'sundays', tat = box.dataset.tat || '', fromTat = false;
        var dispatch = parseInt(box.dataset.dispatch, 10); if (isNaN(dispatch)) dispatch = 1;
        if (box.dataset.useTat === 'true' && tat) {
          var nums = (tat.match(/\d+/g) || []).map(Number).filter(function (n) { return n > 0 && n <= 60; });
          if (nums.length) {
            min = Math.min.apply(null, nums); max = Math.max.apply(null, nums); fromTat = true;
            if (!/business|working/i.test(tat)) skip = 'none';
          }
        }
        if (min > max) { var t = min; min = max; max = t; }
        var today = new Date(); today.setHours(12, 0, 0, 0);
        var fmt = new Intl.DateTimeFormat('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
        var first = fmt.format(addDays(today, min, skip)), last = fmt.format(addDays(today, max, skip));
        return {
          ship: dispatch === 0 ? 'Today' : fmt.format(addDays(today, dispatch, skip)),
          date: min === max ? first : first + ' to ' + last,
          hint: fromTat ? 'Based on ' + tat : 'Usually ' + (min === max ? min : min + ' to ' + max) + ' days'
        };
      }

      check(fromUser) {
        var box = this.querySelector('[data-psb-delivery]');
        if (!box) return;
        var input = box.querySelector('[data-psb-pin]'), date = box.querySelector('[data-psb-date]');
        var d1 = box.querySelector('[data-psb-d1]'), hint = box.querySelector('[data-psb-hint]');
        var error = box.querySelector('[data-psb-error]'), tl = box.querySelector('[data-psb-tl]');
        if (!input || !date) return;
        var pin = input.value.replace(/\D/g, '').slice(0, 6);
        input.value = pin;
        if (!/^\d{6}$/.test(pin)) {
          if (fromUser && error) error.hidden = false;
          date.textContent = date.getAttribute('data-idle') || '';
          if (tl) tl.classList.remove('is-live');
          return;
        }
        if (error) error.hidden = true;
        var est = this.estimate(box);
        date.textContent = est.date;
        if (d1) d1.textContent = est.ship;
        if (hint) hint.textContent = est.hint;
        each([date, d1], function (el) { if (!el) return; el.classList.remove('is-updated'); void el.offsetWidth; el.classList.add('is-updated'); });
        if (tl) tl.classList.add('is-live');
        if (box.dataset.remember === 'true') { try { localStorage.setItem(STORE, pin); } catch (err) {} }
      }
    }

    customElements.define('product-specs', ProductSpecs);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.customElements || customElements.get('size-guide-panel')) return;

    var STORE = 'sg-unit';
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var NUM = '(\\d+)\\s+(\\d+)\\/(\\d+)|(\\d+(?:[.,]\\d+)?)';

    var norm = function (s) { return String(s == null ? '' : s).trim().toLowerCase(); };
    var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
    var toNumber = function (a, b, c, d) { return d ? parseFloat(d.replace(',', '.')) : +a + b / c; };
    var trim = function (n, digits) { return String(+n.toFixed(digits)); };

    function numbers(text) {
      var out = [], re = new RegExp(NUM, 'g'), m;
      while ((m = re.exec(text))) out.push(toNumber(m[1], m[2], m[3], m[4]));
      return out;
    }

    function convert(v, to) {
      if (to === 'cm') {
        var cm = v * 2.54;
        return trim(cm, cm < 30 ? 1 : 0);
      }
      var inch = v / 2.54, step = inch < 20 ? 0.25 : 0.5;
      return trim(Math.round(inch / step) * step, 2);
    }

    function convertText(text, to) {
      return text.replace(new RegExp(NUM, 'g'), function (m, a, b, c, d) {
        return convert(toNumber(a, b, c, d), to);
      });
    }

    class SizeGuidePanel extends HTMLElement {
      connectedCallback() {
        var self = this;
        if (!this._wired) {
          this._wired = true;
          this.addEventListener('click', function (e) { self.onClick(e); });
          this.addEventListener('input', function (e) { self.onField(e); });
          this.addEventListener('change', function (e) { self.onField(e); });
          this.addEventListener('keydown', function (e) { self.onKey(e); });
          this._outside = function (e) { if (!self.contains(e.target)) self.sync(); };
        }
        document.addEventListener('change', this._outside);

        if (this._ready) return;
        var start = function () {
          if (self._ready) return;
          self._ready = true;
          var dialog = self.querySelector('dialog');
          if (dialog) dialog.addEventListener('cancel', function (e) { e.preventDefault(); self.close(); });
          var stored = null;
          try { stored = localStorage.getItem(STORE); } catch (err) {}
          self.applyUnit(stored && self.querySelector('[data-sg-unit-btn]') ? stored : null, false);
          self.sync();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
        else start();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this._outside);
        document.documentElement.classList.remove('sg-lock');
      }

      scope() {
        return this.closest('product-information') || this.closest('.shopify-section') || document;
      }

      onClick(e) {
        var el = e.target.closest ? e.target.closest('[data-sg-open],[data-sg-close],[data-sg-tab],[data-sg-unit-btn],[data-sg-pick]') : null;
        if (!el || !this.contains(el)) return;
        if (el.hasAttribute('data-sg-open')) this.toggle();
        else if (el.hasAttribute('data-sg-close')) this.close();
        else if (el.hasAttribute('data-sg-tab')) this.tab(el);
        else if (el.hasAttribute('data-sg-unit-btn')) this.applyUnit(el.getAttribute('data-sg-unit-btn'), true);
        else if (el.hasAttribute('data-sg-pick')) this.pick(el.getAttribute('data-size'));
      }

      onField(e) {
        if (e.target.matches && e.target.matches('[data-sg-find-col],[data-sg-find-val]')) this.find();
      }

      onKey(e) {
        var tab = e.target.closest ? e.target.closest('[data-sg-tab]') : null;
        if (tab && /^(ArrowLeft|ArrowRight|Home|End)$/.test(e.key)) {
          var tabs = Array.prototype.slice.call(this.querySelectorAll('[data-sg-tab]'));
          var i = tabs.indexOf(tab);
          if (e.key === 'Home') i = 0;
          else if (e.key === 'End') i = tabs.length - 1;
          else i = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          e.preventDefault();
          tabs[i].focus();
          this.tab(tabs[i]);
          return;
        }
        var inline = this.querySelector('[data-sg-inline]');
        if (e.key === 'Escape' && inline && !inline.hidden) {
          this.close();
          var trigger = this.querySelector('[data-sg-open]');
          if (trigger) trigger.focus();
        }
      }

      toggle() {
        var inline = this.querySelector('[data-sg-inline]');
        if (inline && !inline.hidden) this.close();
        else this.open();
      }

      open() {
        var trigger = this.querySelector('[data-sg-open]');
        var dialog = this.querySelector('dialog');
        this.sync();
        if (!dialog) {
          var inline = this.querySelector('[data-sg-inline]');
          if (inline) inline.hidden = false;
        } else if (!dialog.open) {
          dialog.removeAttribute('data-closing');
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
          document.documentElement.classList.add('sg-lock');
        }
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }

      close() {
        var self = this;
        var trigger = this.querySelector('[data-sg-open]');
        var dialog = this.querySelector('dialog');
        if (!dialog) {
          var inline = this.querySelector('[data-sg-inline]');
          if (inline) inline.hidden = true;
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          return;
        }
        if (!dialog.open || this._closing) return;
        this._closing = true;

        var finish = function () {
          if (!self._closing) return;
          self._closing = false;
          dialog.removeAttribute('data-closing');
          if (dialog.open) dialog.close();
          document.documentElement.classList.remove('sg-lock');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        };

        if (reduce && reduce.matches) return finish();

        dialog.setAttribute('data-closing', '');
        var sheet = dialog.querySelector('.sg__sheet');
        var timer = setTimeout(finish, 360);
        sheet.addEventListener('animationend', function done(ev) {
          if (ev.target !== sheet) return;
          sheet.removeEventListener('animationend', done);
          clearTimeout(timer);
          finish();
        });
      }

      tab(button) {
        var self = this;
        each(this.querySelectorAll('[data-sg-tab]'), function (b) {
          var on = b === button;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var pane = self.querySelector('[id="' + b.getAttribute('aria-controls') + '"]');
          if (pane) pane.hidden = !on;
        });
      }

      applyUnit(unit, save) {
        var base = this.dataset.unit || 'in';
        var next = unit === 'cm' || unit === 'in' ? unit : base;
        var previous = this.current || base;
        this.current = next;

        each(this.querySelectorAll('[data-sg-conv]'), function (cell) {
          var original = cell.getAttribute('data-orig') || '';
          cell.textContent = next === base ? original : convertText(original, next);
        });
        each(this.querySelectorAll('[data-sg-unit-label]'), function (el) { el.textContent = '(' + next + ')'; });
        each(this.querySelectorAll('[data-sg-find-unit]'), function (el) { el.textContent = next; });
        each(this.querySelectorAll('[data-sg-unit-btn]'), function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-sg-unit-btn') === next ? 'true' : 'false');
        });

        var input = this.querySelector('[data-sg-find-val]');
        if (input && previous !== next) {
          var typed = parseFloat(String(input.value).replace(',', '.'));
          if (typed > 0) input.value = convert(typed, next);
        }
        if (save) {
          try { localStorage.setItem(STORE, next); } catch (err) {}
        }
        this.find();
      }

      find() {
        var column = this.querySelector('[data-sg-find-col]');
        var input = this.querySelector('[data-sg-find-val]');
        var out = this.querySelector('[data-sg-find-out]');
        var pick = this.querySelector('[data-sg-pick]');
        if (!column || !input || !out) return;

        each(this.querySelectorAll('tr.is-match'), function (r) { r.classList.remove('is-match'); });
        if (pick) pick.hidden = true;

        var raw = parseFloat(String(input.value).replace(',', '.'));
        if (!(raw > 0)) { out.textContent = out.getAttribute('data-idle'); return; }

        var base = this.dataset.unit || 'in';
        var shown = this.current || base;
        var value = shown === base ? raw : base === 'cm' ? raw * 2.54 : raw / 2.54;

        var best = null, bestGap = Infinity;
        each(this.querySelectorAll('tbody tr[data-size]'), function (row) {
          var cell = row.querySelector('[data-col="' + column.value + '"]');
          if (!cell) return;
          var nums = numbers(cell.getAttribute('data-orig') || '');
          if (!nums.length) return;
          var lo = Math.min.apply(null, nums), hi = Math.max.apply(null, nums);
          var gap = value < lo ? lo - value : value > hi ? value - hi : 0;
          if (gap <= bestGap) { bestGap = gap; best = row; }
        });

        if (!best) { out.textContent = out.getAttribute('data-idle'); return; }

        var kind = bestGap === 0 ? 'fit' : bestGap <= value * 0.06 ? 'near' : 'far';
        var size = best.getAttribute('data-size');
        var label = document.createElement('span');
        label.textContent = out.getAttribute('data-' + kind);
        var strong = document.createElement('strong');
        strong.textContent = size;
        out.textContent = '';
        out.appendChild(label);
        out.appendChild(strong);
        var soldOut = best.hasAttribute('data-soldout');
        if (soldOut) {
          var note = document.createElement('span');
          note.textContent = ' ' + (out.getAttribute('data-sold') || '');
          out.appendChild(note);
        }

        best.classList.add('is-match');
        if (pick) {
          pick.setAttribute('data-size', size);
          pick.textContent = (pick.getAttribute('data-tpl') || '{size}').replace('{size}', size);
          pick.hidden = soldOut;
        }
      }

      sync() {
        var rows = this.querySelectorAll('tbody tr[data-size]');
        if (!rows.length) return;
        each(rows, function (r) { r.classList.remove('is-selected'); });
        if (this.dataset.highlight !== 'true') return;

        var self = this, chosen = [], scope = this.scope();
        each(scope.querySelectorAll('input[type="radio"]:checked'), function (i) { if (!self.contains(i)) chosen.push(norm(i.value)); });
        each(scope.querySelectorAll('select'), function (s) { if (!self.contains(s)) chosen.push(norm(s.value)); });
        if (!chosen.length) return;

        each(rows, function (r) {
          if (chosen.indexOf(norm(r.getAttribute('data-size'))) > -1) r.classList.add('is-selected');
        });
      }

      pick(size) {
        var self = this, wanted = norm(size), hit = false, scope = this.scope();
        each(scope.querySelectorAll('input[type="radio"]'), function (i) {
          if (hit || i.disabled || self.contains(i) || norm(i.value) !== wanted) return;
          hit = true;
          if (!i.checked) i.click();
        });
        if (!hit) {
          each(scope.querySelectorAll('select'), function (s) {
            if (hit || self.contains(s)) return;
            each(s.options, function (o) {
              if (hit || o.disabled || norm(o.value) !== wanted) return;
              hit = true;
              s.value = o.value;
              s.dispatchEvent(new Event('change', { bubbles: true }));
            });
          });
        }
        this.close();
      }
    }

    customElements.define('size-guide-panel', SizeGuidePanel);
  })();
  } catch(e) { console.error(e); }
})();

})();
